import {
    CLOSE_JOIN_CHALLENGE_MODAL,
    FETCH_CHALLENGE,
    FETCH_CHALLENGE_FAIL,
    FETCH_CHALLENGE_SUCCESS,
    JOIN_CHALLENGE,
    JOIN_CHALLENGE_SUCCESS,
    JOIN_CHALLENGE_FAIL,
    LEAVE_CHALLENGE,
    LEAVE_CHALLENGE_SUCCESS,
    LEAVE_CHALLENGE_FAIL,
    CLEAN_BADGE_CHALLENGE_PAGE,
    BADGE_CHALLENGE_DETAIL_UPDATE_AUTO_CHALLENGE
} from 'actions/ActionTypes';
import { BADGE_CHALLENGE_DETAIL_OPT_IN_AUTO_CHALLENGE } from '../../actions/ActionTypes';

const INITIAL_STATE = {
    challenges: {},
    fetching: false,
    joinedSuccessDialogOpened: false,
    joinChallengeFullFail: false,
    autoChallenge: null
};

const cleanupBadgeChallenges = (state) => {
    return {
        ...state,
        challenges: {},
        autoChallenge: null
    };
};

const fetchChallengeSuccess = (state, action) => {
    return {
        ...state,
        challenges: {
            ...state.challenges,
            [action.challenge.uuid]: action.challenge
        },
        autoChallenge: action.autoChallenge
    };
};

const joinChallengeFail = (state, action) => {
    if (
        action.error.error === 'ForbiddenException' &&
        action.error.message === "The status of the partner rewards challenge is 'FULL'"
    ) {
        return {
            ...state,
            joinChallengeFullFail: true
        };
    } else {
        return {
            ...state,
            challenges: {
                ...state.challenges,
                [action.challenge.challengeId]: null
            }
        };
    }
};

const joinChallengeSuccess = (state) => {
    return {
        ...state,
        joinedSuccessDialogOpened: true
    };
};

const leaveChallengeSuccess = (state) => {
    return {
        ...state
    };
};

const closeJoinChallengeModal = (state) => {
    return {
        ...state,
        joinedSuccessDialogOpened: false
    };
};

const badgeChallengeDetailUpdateAutoChallenge = (state, action) => {
    return {
        ...state,
        autoChallenge: action.data
    };
};

const handlers = {
    [FETCH_CHALLENGE_SUCCESS]: fetchChallengeSuccess,
    [JOIN_CHALLENGE_SUCCESS]: joinChallengeSuccess,
    [JOIN_CHALLENGE_FAIL]: joinChallengeFail,
    [CLOSE_JOIN_CHALLENGE_MODAL]: closeJoinChallengeModal,
    [LEAVE_CHALLENGE_SUCCESS]: leaveChallengeSuccess,
    [CLEAN_BADGE_CHALLENGE_PAGE]: cleanupBadgeChallenges,
    [BADGE_CHALLENGE_DETAIL_UPDATE_AUTO_CHALLENGE]: badgeChallengeDetailUpdateAutoChallenge
};

export default function challenge(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchChallenge(challengeId) {
    return {
        type: FETCH_CHALLENGE,
        challengeId
    };
}

export function cleanupBadgeChallengePage(challengeId) {
    return {
        type: CLEAN_BADGE_CHALLENGE_PAGE,
        challengeId
    };
}

export function joinChallenge(challengeId) {
    return {
        type: JOIN_CHALLENGE,
        challengeId
    };
}

export function leaveChallenge(challengeId) {
    return {
        type: LEAVE_CHALLENGE,
        challengeId
    };
}

export function closeJoinBadgeChallengeModal() {
    return {
        type: CLOSE_JOIN_CHALLENGE_MODAL
    };
}

/**
 * @param {(error:Error | null) => any} callback opt-in callback, `null` means success, error means something wrong
 * @returns
 */
export function optInAutoChallenge(callback) {
    return {
        type: BADGE_CHALLENGE_DETAIL_OPT_IN_AUTO_CHALLENGE,
        callback
    };
}

// Getters
export const getChallenge = (state, challengeId) => {
    return state.challenge.challenges[challengeId];
};

export const isChallengeFetching = (state) => {
    return state.challenge.fetching;
};

export const getJoinDialogOpened = (state) => {
    return state.challenge.joinedSuccessDialogOpened;
};

export const getChallengeFullFail = (state) => {
    return state.challenge.joinChallengeFullFail;
};

export const getAutoChallenge = (state) => {
    return state.challenge.autoChallenge;
};
